import React from 'react';
import { SectionHead, Icon } from './Primitives';
import './UnityFAQ.css';
const questions = [
  [
    'What can I create during the free trial?',
    'Ask our team about the proposed 14-day authoring trial: one creator and a 10,000-credit allowance for one programme structure and one outcome. The proposed limits are three modules, twelve outcomes in the structure, and English Base content for one outcome with up to five concepts and two images. Source limits are two PDFs, 40 pages total and 15 MiB per file. Our team confirms access, limits, allowances, preview and PDF download options before you start. No credit card is requested in this enquiry.',
  ],
  [
    'What support is available for my first result?',
    'Tell our team about your source material and the outcome you want to create. Before you start, we will confirm trial access, AI allowances, generation limits and the support available for completing your first result. AI usage varies with your material, the task and the chosen model, so the displayed allowance is not a guarantee of a fixed amount of generated content.',
  ],
  [
    'Can I use Unity with our existing LMS?',
    'Unity supports SCORM 1.2 study exports and outcome PDFs, shown in the proposed Create and Create Teams plans. The SCORM export uses English Base content with interactions expanded for reading and review. Native adaptive pathways, games and assessment scoring stay in Unity. Complete the required programme content before exporting a full SCORM package. Our team confirms package availability before you start.',
  ],
  [
    'How does adaptive learning work?',
    'Learners study prepared versions of your content at supported complexity levels. Their lesson-check results guide the complexity of a following lesson, within the programme’s configured bounds. You prepare and review those versions first. Switching between saved versions does not itself make an AI generation call. Adaptive learning is shown in the proposed Deliver and Impact plans; our team confirms your available features.',
  ],
  [
    'How is a monthly active learner counted?',
    'The indicative calculator counts each learner once per month across programmes and applies the proposed included capacity before the displayed usage bands. The proposed activity definition covers learning such as opening a released lesson for study or submitting an assessment, and excludes invitations, enrolment alone and staff preview. Your agreed quote and terms confirm the actual usage rules before learner delivery starts.',
  ],
  [
    'What happens when my AI credits run out?',
    'Check your AI Wallet in your Unity account for your current balance and available funding options. Your billing administrator can review a live funding quote before payment. The credit packs and monthly allowances on this page are illustrative proposals; the account quote and your agreed terms confirm actual charges, funding, credit validity and access. Ask our team about trial allowances and support before you start.',
  ],
  [
    'Can my team review and edit programmes together?',
    'Permitted creators can share authoring access. The proposed Create Teams, Deliver and Impact plans show additional creator seats at R650 per month excluding VAT. The indicative Deliver and Impact pricing includes facilitation for creators and additional facilitator-only seats at R250 per month excluding VAT. Our team confirms roles, capacity and charges in your quote. Shared access does not mean simultaneous live co-editing.',
  ],
  [
    'Can I sell a paid course directly through Unity?',
    'Unity can help you create programmes and run learning for enrolled participants. Native course storefront, learner checkout and creator payouts are not included in these packages. A paid-course business needs a separately arranged payment and enrolment workflow.',
  ],
  [
    'Can we change plans or arrange a larger rollout?',
    'Talk to our team when you need more capability or capacity. We will confirm availability, pricing and the terms for plan changes, billing, renewal and cancellation before you agree. The indicative annual prices show a 15% saving on the platform subscription only. For more than 2,000 monthly active learners, contact us for a scoped rollout and quote.',
  ],
  [
    'Can AI-generated safety or compliance content be published immediately?',
    'You stay responsible for reviewing and approving the programme before release. AI helps organise and draft learning from your material, but it does not certify legal compliance, replace your subject-matter expert, or guarantee that an incident will not recur.',
  ],
];
export default function UnityFAQ() {
  return (
    <section className="ul-section ul-faq" id="faq">
      <div className="ul-container ul-faq-grid">
        <SectionHead
          eyebrow="A few things worth knowing"
          title={
            <>
              Clear answers.
              <br />
              Confident next steps.
            </>
          }
        >
          From your first programme to your next rollout, know exactly what you’re choosing.
        </SectionHead>
        <div className="ul-faq-list">
          {questions.map(([q, a]) => (
            <details key={q}>
              <summary>
                {q}
                <Icon name="plus" size={19} />
              </summary>
              <p>{a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
